import React, { useState, useMemo } from "react";
import Chart from "react-apexcharts";
import "../InsightMenu/InsightPreview.scss";
import QuestionAnalysis from '../../../assets/images/QuestionAnalysis.png';


/* ---------- Helpers ---------- */
const rand = (min, max) =>
    Math.floor(Math.random() * (max - min + 1)) + min;

/* ---------- Static Questions ---------- */
const QUESTIONS = [
    { id: 1, text: "How satisfied are you with the service?" },
    { id: 2, text: "How likely are you to recommend us?" },
    { id: 3, text: "How satisfied are you with response time?" },
    { id: 4, text: "How easy was it to resolve your issue?" }
];

const BAR_COLORS = ["#ff4d4f", "#fa8c16", "#722ed1", "#2563eb", "#52c41a"];

const QuestionAnalysisPreview = () => {
    const [activeQuestion, setActiveQuestion] = useState(QUESTIONS[0]);

    /* ---------- Generate chart per question ---------- */
    const chartConfig = useMemo(() => {
        const values = Array.from({ length: 5 }, () => rand(10, 90));

        return {
            series: [
                {
                    name: "Responses",
                    data: values
                }
            ],
            options: {
                chart: {
                    type: "bar",
                    height: 300,
                    toolbar: { show: false }
                },
                plotOptions: {
                    bar: {
                        distributed: true,
                        borderRadius: 6,
                        columnWidth: "45%"
                    }
                },
                colors: BAR_COLORS,
                xaxis: {
                    categories: [
                        "Strongly Disagree",
                        "Disagree",
                        "Neutral",
                        "Agree",
                        "Strongly Agree"
                    ],
                    labels: { rotate: -10 }
                },
                yaxis: {
                    max: 100,
                    tickAmount: 5
                },
                dataLabels: {
                    enabled: false
                },
                grid: {
                    strokeDashArray: 4
                },
                tooltip: {
                    y: {
                        formatter: val => `${val}%`
                    }
                }
            }
        };
    }, [activeQuestion]);

    return (
        <div className="question-analysis-wrapper row">

            {/* 🟦 LEFT: Question List */}
            {/* <div className="col-md-4 border-end pe-3">
                <h6 className="mb-3">Questions</h6>

                <ul className="question-list">
                    {QUESTIONS.map(q => (
                        <li
                            key={q.id}
                            className={`question-item ${activeQuestion.id === q.id ? "active" : ""
                                }`}
                            onClick={() => setActiveQuestion(q)}
                        >
                            {q.text}
                        </li>
                    ))}
                </ul>
            </div> */}
            <img alt="" src={QuestionAnalysis} className="preview-img w-100" />
            {/* 🟩 RIGHT: Bar Chart */}
            {/* <div className="col-md-8 ps-4">
                <h6 className="mb-3">
                    Question Analysis
                    <span className="text-muted ms-2">
                        ({activeQuestion.text})
                    </span>
                </h6>

                <Chart
                    options={chartConfig.options}
                    series={chartConfig.series}
                    type="bar"
                    height={320}
                />
            </div> */}
        </div>
    );
};

export default QuestionAnalysisPreview;